import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { PendelRoutesClient } from "@/features/pendelRoutes/PendelRoutesClient";
import { listPendelRoutes, pendelRouteKeys } from "@/features/pendelRoutes/pendelRoutes.api";
import { firstAllowedRoute, hasModule } from "@/lib/auth";

// Beheer → Pendelschema (hoofdplanner, 19-10-2026; docs/design_handoff_planning_v3/README.md P31). The planners read it;
// only an admin changes it (Camiel, 20-10-2026), as the API allows.

export const Route = createFileRoute("/_shell/pendel-routes")({
  beforeLoad: ({ context }) => {
    const session = context.session;
    if (!session.roles.includes("admin") && !hasModule(session, "tms_planning") && !hasModule(session, "tms_planning_write")) {
      throw redirect({ to: firstAllowedRoute(session) });
    }
  },
  component: PendelRoutesScreen,
});

function PendelRoutesScreen() {
  const { session } = Route.useRouteContext();
  const routes = useQuery({ queryKey: pendelRouteKeys.list, queryFn: listPendelRoutes });
  const canWrite = session.roles.includes("admin");

  return (
    <div className="wl-page wl-page--list" data-screen-label="Back-office Pendel Routes">
      <PendelRoutesClient
        routes={routes.data ?? []}
        userId={session.userId}
        canWrite={canWrite}
        isFetching={routes.isFetching}
        isLoading={routes.isLoading}
      />
    </div>
  );
}
